import React from 'react';
import { useThemeContext } from 'shared/context/themeContext';
import { dark as darkColors, light as lightColors } from 'shared/theme/colorTokens';

interface Props {
  title: string;
  area?: string;
  subArea?: React.ReactNode;
  toolbar?: React.ReactNode;
}

const PageHeader = (props: Props) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';
  return (
    <div className="flex justify-between items-center h-16 relative w-full " style={{
      background: isDark
        ? darkColors.headerPageGradient
        : lightColors.headerPageGradient,
      height: '65px',
      boxShadow: isDark ? darkColors.glow : lightColors.glow,
      zIndex: 20
    }}>
      <div className="flex flex-col items-start pl-4">
        <h1 className="text-xs text-inkMuted dark:text-inkMuted-dark">{props.area}{props.subArea && ` - ${props.subArea} -`} </h1>
        <div className="flex gap-2 items-center">
          <h1 className="font-medium text-ink dark:text-ink-dark">{props.title}</h1>
        </div>
      </div>
      <div className="flex space-x-2 ">{props.toolbar}</div>
    </div>
  );
};
export default PageHeader;
